import { DayWrapperRenderProps } from '../../..'

type GetDayRelationsResult = Pick<DayWrapperRenderProps, 'isToday' | 'isFuture' | 'isPast'>

export const getDayRelations = (day: Date): GetDayRelationsResult => {
  const normalizedDay = new Date(day)
  const today = new Date()

  normalizedDay.setHours(0, 0, 0, 0)
  today.setHours(0, 0, 0, 0)

  const dayTimestamp = normalizedDay.getTime()
  const todayTimestamp = today.getTime()

  return {
    isToday: dayTimestamp === todayTimestamp,
    isPast: dayTimestamp < todayTimestamp,
    isFuture: dayTimestamp > todayTimestamp,
  }
}
